export const PROMOTION_STATUS = {
  DRAFT: 0,
  MODERATION: 1,
} as const
